var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:("" + (item.id) + index),staticClass:"flex flex-wrap items-center py-5 pl-8 cursor-pointer border-b border-dashed border-grey-darker-200",class:{
      'purple-light-bg purple-text': _vm.activeItem == item.value
    },on:{"click":function($event){return _vm.setItem(item.value)}}},[_c('span',[_vm._v(_vm._s(item.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }